import React from 'react';
import { Link } from 'react-router-dom';
import { useHasSpeakers } from '../../../hooks/useHasSpeakers';

const NAV_ITEMS = [
    { label: 'Home',             to: '/' },
    { label: 'CFP',              to: '/cfp' },
    { label: 'Trainings',        to: '/trainings' },
    { label: 'Speakers',         to: '/speakers' },
    { label: 'CTF',              to: '/ctf' },
    { label: 'About Us',         to: '/about-us' },
    { label: 'Community',        to: '/community-events' },
    { label: 'Volunteers',       to: '/volunteers' },
    { label: 'Contact',          to: '/bsides-contact' },
];

const SOCIALS = [
    { icon: 'fab fa-discord',   href: 'https://discord.gg/bsidescoimbatore',           color: '#5865F2' },
    { icon: 'fab fa-twitter',   href: 'https://twitter.com/BSidesCBE',                 color: '#1DA1F2' },
    { icon: 'fab fa-instagram', href: 'https://instagram.com/bsidescbe',               color: '#E1306C' },
    { icon: 'fab fa-linkedin',  href: 'https://linkedin.com/company/bsidescoimbatore', color: '#0A66C2' },
    { icon: 'fab fa-github',    href: 'https://github.com/bsidescoimbatore',           color: '#fff' },
];

const MobileMenu = ({ handleMobileMenu }) => {
    const hasSpeakers = useHasSpeakers();
    
    // Filter out Speakers if we don't have any
    const activeNavItems = NAV_ITEMS.filter(item => 
        item.label !== 'Speakers' || hasSpeakers
    );

    return (
        <>
            <style>{`
                /* ═══════════════════════════════════
                   BSIDES MOBILE MENU
                ═══════════════════════════════════ */
                .bsides-mob-overlay {
                    position: fixed; inset: 0;
                    background: rgba(0,0,0,0.6);
                    z-index: 9998;
                    backdrop-filter: blur(4px);
                    opacity: 0; pointer-events: none;
                    transition: opacity 0.3s;
                }
                .mobile-menu-visible .bsides-mob-overlay {
                    opacity: 1; pointer-events: all;
                }

                .bsides-mob-drawer {
                    position: fixed;
                    top: 0; right: 0;
                    width: 300px; height: 100vh;
                    background: #0a0010;
                    border-left: 1px solid rgba(var(--eventflow-base-rgb),0.2);
                    z-index: 9999;
                    display: flex; flex-direction: column;
                    transform: translateX(100%);
                    transition: transform 0.35s cubic-bezier(0.4,0,0.2,1);
                    overflow-y: auto;
                    box-shadow: -20px 0 60px rgba(0,0,0,0.6);
                }
                .mobile-menu-visible .bsides-mob-drawer {
                    transform: translateX(0);
                }

                /* top bar */
                .bsides-mob-top {
                    display: flex; align-items: center;
                    justify-content: space-between;
                    padding: 20px 24px;
                    border-bottom: 1px solid rgba(255,255,255,0.06);
                    flex-shrink: 0;
                }
                .bsides-mob-logo img {
                    height: 48px; width: auto;
                    filter: brightness(1.5) contrast(1.1);
                }
                .bsides-mob-close {
                    width: 36px; height: 36px;
                    border-radius: 8px;
                    background: rgba(255,255,255,0.06);
                    border: 1px solid rgba(255,255,255,0.1);
                    display: flex; align-items: center; justify-content: center;
                    cursor: pointer; color: rgba(255,255,255,0.7);
                    font-size: 16px; transition: all 0.2s;
                    flex-shrink: 0;
                }
                .bsides-mob-close:hover {
                    background: rgba(var(--eventflow-base-rgb),0.2);
                    border-color: rgba(var(--eventflow-base-rgb),0.4);
                    color: #fff;
                }

                /* event badge */
                .bsides-mob-badge {
                    margin: 16px 24px;
                    background: rgba(var(--eventflow-base-rgb),0.08);
                    border: 1px solid rgba(var(--eventflow-base-rgb),0.2);
                    border-radius: 10px;
                    padding: 12px 16px;
                    display: flex; align-items: center; gap: 10px;
                    flex-shrink: 0;
                }
                .bsides-mob-badge__dot {
                    width: 8px; height: 8px; border-radius: 50%;
                    background: var(--eventflow-base);
                    animation: mobDotPulse 1.8s ease-in-out infinite;
                    flex-shrink: 0;
                }
                @keyframes mobDotPulse {
                    0%,100%{opacity:1;transform:scale(1);}
                    50%{opacity:0.3;transform:scale(1.6);}
                }
                .bsides-mob-badge__text {
                    font-family: var(--eventflow-font);
                    font-size: 12px; color: rgba(255,255,255,0.6);
                    line-height: 1.4;
                }
                .bsides-mob-badge__text strong {
                    color: #fff; display: block; font-size: 13px;
                }

                /* nav links */
                .bsides-mob-nav {
                    padding: 8px 0;
                    flex: 1;
                }
                .bsides-mob-nav__item {
                    display: flex; align-items: center;
                    padding: 0 24px;
                    border-bottom: 1px solid rgba(255,255,255,0.04);
                }
                .bsides-mob-nav__link {
                    display: flex; align-items: center;
                    justify-content: space-between;
                    width: 100%;
                    padding: 14px 0;
                    font-family: var(--eventflow-font);
                    font-size: 16px; font-weight: 600;
                    color: rgba(255,255,255,0.75);
                    text-decoration: none;
                    transition: color 0.2s;
                }
                .bsides-mob-nav__link:hover,
                .bsides-mob-nav__link.active {
                    color: var(--eventflow-base);
                }
                .bsides-mob-nav__link i {
                    font-size: 12px; color: rgba(255,255,255,0.2);
                    transition: color 0.2s, transform 0.2s;
                }
                .bsides-mob-nav__link:hover i { color: var(--eventflow-base); transform: translateX(3px); }

                /* CTA button */
                .bsides-mob-cta {
                    padding: 20px 24px;
                    border-top: 1px solid rgba(255,255,255,0.06);
                    flex-shrink: 0;
                }
                .bsides-mob-cta .thm-btn {
                    width: 100% !important;
                    justify-content: center !important;
                    border-radius: 10px !important;
                    padding: 13px 20px !important;
                    font-size: 15px !important;
                }

                /* contact info */
                .bsides-mob-contact {
                    padding: 0 24px 16px;
                    flex-shrink: 0;
                }
                .bsides-mob-contact__item {
                    display: flex; align-items: center; gap: 10px;
                    font-family: var(--eventflow-font);
                    font-size: 13px; color: rgba(255,255,255,0.4);
                    margin-bottom: 8px; text-decoration: none;
                    transition: color 0.2s;
                }
                .bsides-mob-contact__item:hover { color: rgba(255,255,255,0.7); }
                .bsides-mob-contact__item i { color: var(--eventflow-base); font-size: 13px; width: 14px; }

                /* socials */
                .bsides-mob-socials {
                    padding: 16px 24px 28px;
                    border-top: 1px solid rgba(255,255,255,0.06);
                    display: flex; gap: 10px; flex-wrap: wrap;
                    flex-shrink: 0;
                }
                .bsides-mob-social {
                    width: 36px; height: 36px; border-radius: 8px;
                    display: flex; align-items: center; justify-content: center;
                    font-size: 15px; text-decoration: none;
                    background: rgba(255,255,255,0.05);
                    border: 1px solid rgba(255,255,255,0.08);
                    transition: all 0.25s;
                }
                .bsides-mob-social:hover {
                    transform: translateY(-2px);
                    border-color: rgba(255,255,255,0.2);
                }
            `}</style>

            {/* Overlay */}
            <div className="bsides-mob-overlay mobile-nav__toggler" onClick={handleMobileMenu} />

            {/* Drawer */}
            <div className="bsides-mob-drawer">

                {/* Top bar */}
                <div className="bsides-mob-top">
                    <Link to="/" className="bsides-mob-logo" onClick={handleMobileMenu}>
                        <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="BSides Coimbatore" />
                    </Link>
                    <div className="bsides-mob-close" onClick={handleMobileMenu}>
                        <i className="fa fa-times" />
                    </div>
                </div>

                {/* Event badge */}
                <div className="bsides-mob-badge">
                    <span className="bsides-mob-badge__dot" />
                    <div className="bsides-mob-badge__text">
                        <strong>BSides Coimbatore 2027</strong>
                        September 15, 2027
                    </div>
                </div>

                {/* Nav links */}
                <nav className="bsides-mob-nav">
                    {activeNavItems.map((item, i) => (
                        <div className="bsides-mob-nav__item" key={i}>
                            <Link
                                to={item.to}
                                className="bsides-mob-nav__link"
                                onClick={handleMobileMenu}
                            >
                                {item.label}
                                <i className="fa fa-arrow-right" />
                            </Link>
                        </div>
                    ))}
                </nav>

                {/* CTA */}
                <div className="bsides-mob-cta">
                    <Link to="/bsides-contact" className="thm-btn" onClick={handleMobileMenu}>
                        Register Now — Free <span className="icon-arrow-right" />
                    </Link>
                </div>

                {/* Contact */}
                <div className="bsides-mob-contact">
                    <a href="mailto:info@bsidescoimbatore.in" className="bsides-mob-contact__item">
                        <i className="fa fa-envelope" /> info@bsidescoimbatore.in
                    </a>
                    <a href="https://maps.google.com/?q=CODISSIA+Coimbatore" className="bsides-mob-contact__item" target="_blank" rel="noopener noreferrer">
                        <i className="fa fa-map-marker-alt" /> Coimbatore, Tamil Nadu
                    </a>
                </div>

                {/* Socials */}
                <div className="bsides-mob-socials">
                    {SOCIALS.map((s, i) => (
                        <a
                            key={i}
                            href={s.href}
                            className="bsides-mob-social"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: s.color }}
                        >
                            <i className={s.icon} />
                        </a>
                    ))}
                </div>
            </div>
        </>
    );
};

export default MobileMenu;
